(function () {
  const STORAGE_KEY = 'map-signup-sticky-dismissed';

  function initSignupSticky() {
    const portal = document.querySelector('[data-signup-sticky-portal]');
    const bar = document.querySelector('[data-signup-sticky]');
    if (!portal || !bar) return;

    if (window.localStorage.getItem(STORAGE_KEY) === '1') {
      portal.hidden = true;
      return;
    }

    // Viewport-fixed on body — never scroll with page sections.
    document.body.appendChild(portal);

    let dismissed = false;
    let heroInView = Boolean(document.querySelector('.home-hero'));
    let newsletterVisible = false;
    let footerCoversPill = false;
    const onProductPage = Boolean(document.querySelector('.product-page'));
    const mobileQuery = window.matchMedia('(max-width: 47.99rem)');

    const scrollTarget = document.querySelector(bar.dataset.scrollTarget || '#newsletter-signup');
    const hero = document.querySelector('.home-hero');
    const footer = document.querySelector('.site-footer');
    const FOOTER_GAP = 16;
    const PREVIEW_BAR_SELECTORS = ['#preview-bar-iframe', '[data-preview-bar]', 'iframe[src*="preview_bar"]'];

    function measureChromeBottom() {
      let inset = 0;
      PREVIEW_BAR_SELECTORS.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (!(el instanceof HTMLElement)) return;
          const rect = el.getBoundingClientRect();
          if (rect.height <= 0 || rect.height > 80) return;
          if (rect.bottom < window.innerHeight - 4) return;
          inset = Math.max(inset, Math.round(window.innerHeight - rect.top));
        });
      });
      // Shopify CLI preview bar overlays the storefront on theme:dev.
      if (
        inset === 0 &&
        (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost')
      ) {
        inset = 48;
      }
      return inset;
    }

    function applyChromeBottom() {
      const inset = measureChromeBottom();
      if (inset > 0) {
        portal.style.setProperty('--signup-chrome-bottom', `${inset}px`);
      } else {
        portal.style.removeProperty('--signup-chrome-bottom');
      }
      return inset;
    }

    function visualBottom() {
      return window.innerHeight - applyChromeBottom();
    }

    function syncNewsletterState(entry) {
      if (!scrollTarget) {
        newsletterVisible = false;
        return;
      }

      const rect = entry ? entry.boundingClientRect : scrollTarget.getBoundingClientRect();
      newsletterVisible = entry
        ? entry.isIntersecting
        : rect.top < window.innerHeight && rect.bottom > 0;
    }

    function placeAboveFooter() {
      const bottomEdge = visualBottom();

      if (!footer) {
        footerCoversPill = false;
        portal.style.removeProperty('--signup-sticky-lift');
        return;
      }

      const footerTop = footer.getBoundingClientRect().top;
      const overlap = bottomEdge - footerTop;

      if (overlap <= 0) {
        footerCoversPill = false;
        portal.style.removeProperty('--signup-sticky-lift');
        return;
      }

      const lift = overlap + FOOTER_GAP;
      const portalHeight = portal.offsetHeight || 48;
      const maxLift = bottomEdge - portalHeight - FOOTER_GAP;

      if (lift > maxLift) {
        footerCoversPill = true;
        portal.style.removeProperty('--signup-sticky-lift');
        return;
      }

      footerCoversPill = false;
      portal.style.setProperty('--signup-sticky-lift', `${lift}px`);
    }

    function suppressedOnProductMobile() {
      return onProductPage && mobileQuery.matches;
    }

    function syncVisibility() {
      const show =
        !dismissed && !heroInView && !newsletterVisible && !footerCoversPill && !suppressedOnProductMobile();
      portal.hidden = !show;

      if (show) {
        document.documentElement.dataset.signupSticky = 'visible';
        placeAboveFooter();
      } else {
        delete document.documentElement.dataset.signupSticky;
        portal.style.removeProperty('--signup-sticky-lift');
      }
    }

    let layoutRaf = 0;

    function onLayoutChange() {
      if (layoutRaf) return;
      layoutRaf = window.requestAnimationFrame(() => {
        layoutRaf = 0;
        syncNewsletterState(null);
        placeAboveFooter();
        syncVisibility();
      });
    }

    if ('IntersectionObserver' in window && hero) {
      const heroObserver = new IntersectionObserver(
        ([entry]) => {
          heroInView = entry.isIntersecting;
          syncVisibility();
        },
        { threshold: 0, rootMargin: '0px' }
      );
      heroObserver.observe(hero);
    }

    if ('IntersectionObserver' in window && scrollTarget) {
      const newsletterObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.length) return;
          syncNewsletterState(entries[0]);
          syncVisibility();
        },
        { threshold: 0, rootMargin: '0px' }
      );

      newsletterObserver.observe(scrollTarget);
    }

    window.addEventListener('scroll', onLayoutChange, { passive: true });
    window.addEventListener('resize', onLayoutChange);
    window.addEventListener('load', onLayoutChange);
    mobileQuery.addEventListener('change', onLayoutChange);

    const chromeObserver = new MutationObserver(onLayoutChange);
    chromeObserver.observe(document.documentElement, { childList: true });
    chromeObserver.observe(document.body, { childList: true });
    [300, 800, 1600].forEach((ms) => window.setTimeout(onLayoutChange, ms));

    if ('IntersectionObserver' in window && footer) {
      const footerObserver = new IntersectionObserver(
        () => {
          onLayoutChange();
        },
        { threshold: [0, 0.01, 0.1, 0.25, 0.5, 1], rootMargin: '0px' }
      );
      footerObserver.observe(footer);
    }

    bar.querySelector('[data-signup-sticky-close]')?.addEventListener('click', () => {
      dismissed = true;
      syncVisibility();
      window.localStorage.setItem(STORAGE_KEY, '1');
    });

    bar.querySelector('[data-signup-sticky-cta]')?.addEventListener('click', (event) => {
      const modal = document.getElementById('NewsletterSignupModal');
      if (modal instanceof HTMLDialogElement) return;

      event.preventDefault();
      const selector = bar.dataset.scrollTarget || '#newsletter-signup';
      const target = document.querySelector(selector);

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const email = target.querySelector('input[type="email"]');
        if (email instanceof HTMLInputElement) {
          window.setTimeout(() => email.focus(), 400);
        }
      }
    });

    onLayoutChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSignupSticky);
  } else {
    initSignupSticky();
  }
})();
